/* Roger's — abrir megamenu no HOVER (desktop) + transitar entre menus */
(function () {
  function isDesktop() {
    return !window.matchMedia || window.matchMedia('(min-width: 990px)').matches;
  }
  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    if (!menus.length) return;
    menus.forEach(function (hm) {
      var det = hm.querySelector('details.mega-menu');
      if (!det) return;
      var timer;
      hm.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(timer);
        document
          .querySelectorAll('.header__inline-menu details.mega-menu[open]')
          .forEach(function (d) { if (d !== det) d.removeAttribute('open'); });
        det.setAttribute('open', '');
      });
      hm.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        timer = setTimeout(function () { det.removeAttribute('open'); }, 160);
      });
      // clicar no título leva pra página da categoria (não só abrir)
      var summary = det.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (!isDesktop()) return;
          var link = hm.getAttribute('data-url') || '';
        });
      }
    });
    // fecha tudo ao sair da barra de navegação
    var bar = document.querySelector('.header__inline-menu');
    if (bar) {
      bar.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        setTimeout(function () {
          document
            .querySelectorAll('.header__inline-menu details.mega-menu[open]')
            .forEach(function (d) {
              if (!d.matches(':hover')) d.removeAttribute('open');
            });
        }, 180);
      });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   Rogers — Seletor de CEP "Enviar para" (estilo Netshoes)
   - Detecta localização aproximada por IP ao entrar (1ª visita)
   - Reaproveita CEP salvo (compra/cálculo anterior em localStorage)
   - Permite digitar o CEP (busca cidade via ViaCEP)
   ============================================================ */
(function () {
  var KEY = 'rg_cep';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
    }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  function format(o) {
    if (!o) return null;
    var loc = [o.city, o.uf].filter(Boolean).join(' - ');
    var cep = o.cep ? o.cep + (loc ? ', ' : '') : '';
    return (cep + loc) || null;
  }

  function render() {
    var o = load();
    var txt = format(o);
    if (txt) {
      document.querySelectorAll('.js-cep-value').forEach(function (el) { el.textContent = txt; });
    }
    // notifica o restante do site (faixa de frete da home, badges nos cards, etc.)
    try { window.dispatchEvent(new CustomEvent('rg:cepchange', { detail: o })); } catch (e) {}
  }

  function geoFromIP() {
    // ipapi.co (tem CEP) → fallback geojs (cidade/UF)
    return fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.city) return { cep: d.postal || '', city: d.city, uf: d.region_code || '', approx: true };
        throw 0;
      })
      .catch(function () {
        return fetch('https://get.geojs.io/v1/ip/geo.json')
          .then(function (r) { return r.json(); })
          .then(function (d) { return (d && d.city) ? { cep: '', city: d.city, uf: '', approx: true } : null; })
          .catch(function () { return null; });
      });
  }

  function detectByIP() {
    geoFromIP().then(function (o) { if (o) { save(o); render(); } });
  }

  function lookupCEP(raw) {
    var cep = (raw || '').replace(/\D/g, '');
    if (cep.length !== 8) return Promise.resolve(false);
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.erro) return false;
        save({ cep: cep.slice(0, 5) + '-' + cep.slice(5), city: d.localidade || '', uf: d.uf || '' });
        render();
        return true;
      })
      .catch(function () { return false; });
  }

  var openPop = null;
  function rgCepOutside(e) { if (openPop && !openPop.contains(e.target) && !(e.target.closest && e.target.closest('.js-cep-trigger'))) closePop(); }
  function closePop() { if (openPop) { openPop.remove(); openPop = null; } var b = document.querySelector('.rg-cep-backdrop'); if (b) b.remove(); document.removeEventListener('mousedown', rgCepOutside); }

  function openPopover(trigger) {
    closePop();
    var saved = load();
    var savedCep = (saved && saved.cep) ? String(saved.cep).replace(/[^0-9-]/g, '').slice(0, 9) : '';
    var backdrop = document.createElement('div');
    backdrop.className = 'rg-cep-backdrop';
    backdrop.addEventListener('click', closePop);
    document.body.appendChild(backdrop);

    var pop = document.createElement('div');
    pop.className = 'rg-cep-pop';
    pop.innerHTML =
      '<button type="button" id="rg-cep-close" aria-label="Fechar" style="position:absolute;top:8px;right:8px;width:30px;height:30px;border:0;background:transparent;font-size:24px;line-height:1;color:#9a9aa2;cursor:pointer;border-radius:50%;display:flex;align-items:center;justify-content:center;">&times;</button>' +
      '<p class="rg-cep-pop__title" style="padding-right:26px;">Informe seu CEP</p>' +
      '<p class="rg-cep-pop__sub">Veja prazos e fretes para a sua região.</p>' +
      '<div class="rg-cep-pop__row">' +
        '<input class="rg-cep-pop__input" id="rg-cep-input" inputmode="numeric" maxlength="9" placeholder="00000-000" value="' + savedCep + '">' +
        '<button class="rg-cep-pop__btn" id="rg-cep-ok">OK</button>' +
      '</div>' +
      '<div class="rg-cep-pop__err" id="rg-cep-err"></div>' +
      '<button class="rg-cep-pop__geo" id="rg-cep-geo">Usar minha localização aproximada</button>' +
      '<a class="rg-cep-pop__link" href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" rel="noopener">Não sei meu CEP</a>';
    document.body.appendChild(pop);

    // posiciona perto do gatilho
    var r = trigger.getBoundingClientRect();
    var top = window.scrollY + r.bottom + 8;
    var left = window.scrollX + r.left;
    if (left + 300 > window.innerWidth) left = window.innerWidth - 312;
    if (left < 12) left = 12;
    pop.style.top = top + 'px';
    pop.style.left = left + 'px';
    openPop = pop;
    var closeBtn = pop.querySelector('#rg-cep-close');
    if (closeBtn) closeBtn.addEventListener('click', closePop);
    setTimeout(function () { document.addEventListener('mousedown', rgCepOutside); }, 0);

    var input = pop.querySelector('#rg-cep-input');
    var err = pop.querySelector('#rg-cep-err');
    input.focus();
    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '').slice(0, 8);
      if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
      input.value = v;
    });
    function submit() {
      err.textContent = '';
      lookupCEP(input.value).then(function (ok) {
        if (ok) closePop(); else err.textContent = 'CEP não encontrado. Verifique e tente de novo.';
      });
    }
    pop.querySelector('#rg-cep-ok').addEventListener('click', submit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    pop.querySelector('#rg-cep-geo').addEventListener('click', function () {
      err.textContent = 'Localizando...';
      geoFromIP().then(function (o) {
        if (o) { save(o); render(); closePop(); }
        else err.textContent = 'Não foi possível localizar.';
      });
    });
  }

  function initCep() {
    render();
    var saved = load();
    // auto-detecta na 1ª visita OU quando o valor salvo é aproximado (mantém só CEP digitado manualmente)
    if (!saved || saved.approx) detectByIP();
    document.querySelectorAll('.js-cep-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPopover(el); });
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
  }

  if (document.readyState !== 'loading') initCep();
  else document.addEventListener('DOMContentLoaded', initCep);
})();

/* ============================================================
   Rogers — Dropdown da CONTA no toque/clique (mobile + desktop)
   ============================================================ */
(function () {
  function init() {
    var accounts = document.querySelectorAll('.js-account');
    if (!accounts.length) return;
    accounts.forEach(function (acc) {
      var btn = acc.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        // fecha outros
        accounts.forEach(function (o) { if (o !== acc) o.classList.remove('is-open'); });
      });
    });
    // fecha ao clicar fora
    document.addEventListener('click', function (e) {
      accounts.forEach(function (acc) {
        if (!acc.contains(e.target)) acc.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') accounts.forEach(function (acc) { acc.classList.remove('is-open'); });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   Rogers — Favoritos (wishlist) via localStorage
   - Coração nos cards (.js-fav-btn) + contador no topo (.js-fav-count)
   - Página /favoritos renderiza os salvos (#rgh-favs-grid)
   ============================================================ */
(function () {
  var KEY = 'rg_favs';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function indexOfH(a, h) { for (var i = 0; i < a.length; i++) { if (a[i].h === h) return i; } return -1; }
  function brl(n) { return 'R$ ' + (Number(n) || 0).toFixed(2).replace('.', ','); }

  function updateBadge() {
    var n = load().length;
    document.querySelectorAll('.js-fav-count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }
  function paintHearts() {
    var favs = load();
    document.querySelectorAll('.js-fav-btn').forEach(function (btn) {
      var on = indexOfH(favs, btn.getAttribute('data-fav-h')) >= 0;
      btn.classList.toggle('is-fav', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });
  }
  function toggle(btn) {
    var h = btn.getAttribute('data-fav-h'); if (!h) return;
    var a = load(); var i = indexOfH(a, h);
    if (i >= 0) { a.splice(i, 1); }
    else {
      a.push({
        h: h, t: btn.getAttribute('data-fav-t') || '', v: btn.getAttribute('data-fav-v') || '',
        img: btn.getAttribute('data-fav-img') || '', p: parseFloat(btn.getAttribute('data-fav-p')) || 0,
        c: parseFloat(btn.getAttribute('data-fav-c')) || 0, u: btn.getAttribute('data-fav-u') || ('/products/' + h)
      });
    }
    save(a); paintHearts(); updateBadge(); renderFavsPage();
    try { window.dispatchEvent(new CustomEvent('rg:favchange', { detail: { count: a.length } })); } catch (e) {}
  }

  function btnFromEvent(e) { return (e.target && e.target.closest) ? e.target.closest('.js-fav-btn') : null; }
  document.addEventListener('click', function (e) {
    var btn = btnFromEvent(e); if (!btn) return;
    e.preventDefault(); e.stopPropagation(); toggle(btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = btnFromEvent(e); if (!btn) return;
    e.preventDefault(); e.stopPropagation(); toggle(btn);
  });

  /* ---- Página de Favoritos (#rgh-favs-grid) ---- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '"' ? '&quot;' : '&#39;';
    });
  }
  function cardHTML(it) {
    var onSale = it.c && it.c > it.p;
    var nParc = Math.min(12, Math.floor(it.p / 30));
    var parc = nParc >= 2 ? ('ou ' + nParc + 'x de ' + brl(it.p / nParc) + ' sem juros') : '';
    var off = onSale ? '<span class="rgh-prodcard__off">-' + Math.round((it.c - it.p) / it.c * 100) + '% OFF</span>' : '';
    var old = onSale ? '<span class="rgh-prodcard__old">' + brl(it.c) + '</span>' : '';
    var h = esc(it.h), t = esc(it.t), v = esc(it.v), u = esc(it.u || '#'), img = esc(it.img);
    var heart = '<span class="rgh-prodcard__fav js-fav-btn is-fav" role="button" tabindex="0" aria-pressed="true" aria-label="Remover dos favoritos" data-fav-h="' + h + '"><svg class="rgh-prodcard__fav-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span>';
    var imgTag = img ? '<img src="' + img + '" alt="' + t + '" loading="lazy" width="300" height="300">' : '';
    return '<a class="rgh-prodcard" href="' + u + '" aria-label="' + t + '">' +
      '<div class="rgh-prodcard__imgwrap">' + imgTag + off + heart + '</div>' +
      '<div class="rgh-prodcard__body">' +
        (v ? '<span class="rgh-prodcard__brand">' + v + '</span>' : '') +
        '<span class="rgh-prodcard__name">' + t + '</span>' +
        '<div class="rgh-prodcard__price">' + old +
          '<span class="rgh-prodcard__now">' + brl(it.p) + '</span>' +
          '<span class="rgh-prodcard__pix">' + brl(it.p * 0.95) + ' no Pix</span>' +
          (parc ? '<span class="rgh-prodcard__inst">' + parc + '</span>' : '') +
        '</div>' +
      '</div>' +
    '</a>';
  }
  function renderFavsPage() {
    var grid = document.getElementById('rgh-favs-grid');
    if (!grid) return;
    var favs = load();
    var empty = document.getElementById('rgh-favs-empty');
    var cnt = document.getElementById('rgh-favs-count');
    if (!favs.length) {
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      if (cnt) cnt.textContent = '';
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    grid.innerHTML = favs.map(cardHTML).join('');
    if (cnt) cnt.textContent = favs.length + (favs.length === 1 ? ' produto salvo' : ' produtos salvos');
  }

  function favInit() { paintHearts(); updateBadge(); renderFavsPage(); }
  if (document.readyState !== 'loading') favInit();
  else document.addEventListener('DOMContentLoaded', favInit);
  // Repinta os corações quando os cards são trocados via AJAX (ex.: filtros da coleção)
  document.addEventListener('rg:cards-updated', paintHearts);
})();

/* ============================================================
   Rogers — Placeholder da busca: "O que você precisa?" no mobile
   (mantém o texto descritivo no desktop)
   ============================================================ */
(function () {
  function initPh() {
    var input = document.getElementById('ms-desktop-input');
    if (!input) return;
    var deskPh = input.getAttribute('placeholder') || 'Busque por tênis, marcas, modelos...';
    var mq = window.matchMedia('(max-width: 989px)');
    function apply() { input.setAttribute('placeholder', mq.matches ? 'O que você precisa?' : deskPh); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    // Lupa clicável: busca se houver texto, senão foca o campo
    var wrap = input.closest('.header-search-inline__input-wrapper');
    var icon = wrap ? wrap.querySelector('svg') : null;
    var form = document.getElementById('ms-desktop-form');
    if (icon && form) {
      icon.style.cursor = 'pointer';
      icon.addEventListener('click', function () { if (input.value.trim()) form.submit(); else input.focus(); });
    }
  }
  if (document.readyState !== 'loading') initPh();
  else document.addEventListener('DOMContentLoaded', initPh);
})();
